export { default } from './elementTypeAcceptingRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/elementTypeAcceptingRef/index.js
// module id = 139
// module chunks = 25